module.exports = __webpack_public_path__ + "static/img/9.6c2b065.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/9.png
// module id = Vkju
// module chunks = 0